const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  access_token: state => state.user.access_token,
  access_token_expired_time: state => state.user.access_token_expired_time,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  menuAuthList: state => state.user.menuAuthList,
  menuIdList: state => state.user.menuIdList,
  menuAuthIdList: state => state.user.menuAuthIdList,
  isLock: state => state.user.isLock,
  lockPasswd: state => state.user.lockPasswd,
  lockUrl: state => state.user.lockUrl
}
export default getters
